export default __webpack_public_path__ + "static/media/qr_chplay_okara_mz.9bdcee51.svg";